import React, { useEffect, useRef, useState } from 'react';
import OttoAlive from './OttoAlive';
import { playHeadCock, COCK, COCK_FLOOR_MS } from './ottoHeadCock';
import { beginEventShot } from './ottoStage';
import './otto.css';

// Inline loading scene — Otto stands beside a bar and cocks his head at it
// while a request is in flight (build brief 05).
//
// SPLIT BY CONTEXT (brief §6, signed off 2026-08-07). This does NOT replace
// OttoLoading: that stays on full-page loads where Otto is the whole scene and
// the flying hover reads standalone. This one is for inline / partial loads —
// saving a row, refreshing a panel — where there is a visible bar for him to
// actually look at, and he sits beside the thing that's loading. The shot is
// meaningless without that bar, which is why the bar is part of this component
// rather than something a caller opts into.
//
// Unlike every other shot in the set this one is EVENT-DRIVEN: it runs as long
// as the request does. See ottoHeadCock.js for the in/loop/out driver.
//
// Admin-only, like the rest of Otto — never render on a supplier surface.

const SIZE_MAP = { small: 44, medium: 56, large: 72 };

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default function OttoInlineLoading({
  active,
  message,
  size = 'medium',
  // Below this the whole scene is suppressed: a request that lands in 200ms
  // would otherwise show an intro immediately chased by an outro, which reads
  // as a flinch (brief §5). Better to show nothing.
  floorMs = COCK_FLOOR_MS,
  className = '',
}) {
  const px = SIZE_MAP[size] || SIZE_MAP.medium;
  // `shown` is the floor gate; `leaving` keeps the scene mounted for the outro
  // so the head unwinds instead of vanishing mid-cock.
  const [shown, setShown] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const owlRef = useRef(null);
  const barRef = useRef(null);
  const stopRef = useRef(null);
  const endShotRef = useRef(null);

  // The floor. Nothing renders until a request has been in flight this long.
  useEffect(() => {
    if (!active) return undefined;
    const t = setTimeout(() => setShown(true), floorMs);
    return () => clearTimeout(t);
  }, [active, floorMs]);

  // Start the shot once the scene is actually on screen (the gaze is measured
  // from live rects, so it has to run after layout, not before).
  useEffect(() => {
    if (!shown || leaving) return undefined;
    if (prefersReducedMotion()) return undefined;   // bar + label still render
    const el = owlRef.current;
    if (!el) return undefined;
    // Event shots pre-empt the idle scheduler and reset its timer on the way
    // out, so a roam can't start on top of a request the user just triggered.
    endShotRef.current = beginEventShot();
    stopRef.current = playHeadCock(el, { barEl: barRef.current });
    return () => {
      // Unmounted mid-flight (route change, parent teardown): drop the shot
      // without the outro, but always release the scheduler.
      if (stopRef.current) { stopRef.current(); stopRef.current = null; }
      if (endShotRef.current) { endShotRef.current(); endShotRef.current = null; }
    };
  }, [shown, leaving]);

  // Request finished — unwind from wherever the head is, then unmount.
  useEffect(() => {
    if (active) { setLeaving(false); return undefined; }
    if (!shown) return undefined;
    let cancelled = false;
    setLeaving(true);
    const finish = () => {
      if (cancelled) return;
      setShown(false);
      setLeaving(false);
      if (endShotRef.current) { endShotRef.current(); endShotRef.current = null; }
    };
    if (stopRef.current) {
      stopRef.current().then(finish);
      stopRef.current = null;
    } else {
      setTimeout(finish, COCK.out);   // reduced motion: nothing to unwind
    }
    return () => { cancelled = true; };
  }, [active, shown]);

  if (!shown) return null;

  // The caption is NOT optional. Under reduced motion the sweep stills, and
  // the label is then the only thing carrying the information — see the note
  // on .otto-loadbar in otto.css.
  const caption = message
    ? `${String(message).replace(/[.…\s]+$/, '')}…`
    : 'Loading…';

  return (
    <div className={`otto-inline-load ${className}`.trim()} role="status" aria-live="polite">
      <div className="otto-inline-load-owl" ref={owlRef}>
        {/* OttoAlive, not Otto: only it renders the .otto-pupils group the
            locked gaze drives. interactive={false} so his idle loop and
            cursor-follow can't fight the shot. */}
        <OttoAlive size={px} interactive={false} ariaLabel="" />
      </div>
      <div className="otto-inline-load-main">
        <div className="otto-loadbar" ref={barRef} style={{ width: 180, height: 6 }}><span /></div>
        <p className="font-['Metropolis'] text-sm font-semibold text-ink-secondary">{caption}</p>
      </div>
    </div>
  );
}
